import moment from 'moment';

export const formatDate = dateISOString => {
  return moment(dateISOString).format('M/D/YYYY');
};

export const formatTime = dateISOString => {
  return moment(dateISOString).format('h:mm A');
};